import { status, json, getDataFromResponse } from '../controllers/Fetch';
import { PortalMenu, FrontPageConfig, BatchBookmarksResponse, StreamTypeNumber } from '../interfaces';
import { getBaseUrl, getSessionTicket } from '../config';

export function loadPortalMenuFromBackend(bossId: string, areaId: string, useDefaultConfig: boolean = false) {
  return fetch(
    useDefaultConfig ? '/portal-menu-stb.json' : `${getBaseUrl()}/EPG/CONFIG/${bossId}/${areaId}/portal-menu-stb.json`,
  )
    .then(status)
    .then((r) => json(r as Response))
    .then((response: PortalMenu[]) => {
      return response;
    });
}

export function loadSvodConfigFromBackend(bossId: string, areaId: string, useDefaultConfig: boolean = false) {
  return fetch(
    useDefaultConfig
      ? '/portal-menu-stb.json'
      : `${getBaseUrl()}/EPG/CONFIG/${bossId}/${areaId}/svod-kiosk-mapping.json`,
  )
    .then(status)
    .then((r) => json(r as Response))
    .then((response: PortalMenu[]) => {
      return response.filter((x) => x);
    });
}

export function loadFrontPageConfigFromBackend(bossId: string, areaId: string) {
  const frontPageConfigUrl = `${getBaseUrl()}/EPG/CONFIG/${bossId}/${areaId}/front-page.json`;
  return fetch(frontPageConfigUrl)
    .then(status)
    .then((r) => json(r as Response))
    .then((response: FrontPageConfig) => {
      return response;
    })
    .catch(() => {
      return fetch('/front-page.json')
        .then(status)
        .then((r) => json(r as Response))
        .then((response: FrontPageConfig) => {
          return response;
        });
    });
}

export function loadAllBookmarks() {
  return fetch(getBaseUrl() + '/EPG/JSON/ExecuteBatch', {
    method: 'POST',
    headers: { SessionTicket: getSessionTicket() },
    body: JSON.stringify({
      requestList: [
        {
          name: 'QueryBookmark',
          param: {
            bookmarkType: StreamTypeNumber.VOD,
          },
        },
        {
          name: 'QueryBookmark',
          param: {
            bookmarkType: StreamTypeNumber.PVR,
          },
        },
        {
          name: 'QueryBookmark',
          param: {
            bookmarkType: StreamTypeNumber.CATCHUP,
          },
        },
      ],
    }),
  })
    .then(status)
    .then((r) => json(r as Response))
    .then((bookmarksResponse: BatchBookmarksResponse) => {
      return bookmarksResponse;
    });
}

export async function getContinueWatchingPadding(): Promise<[prePadding: number, postPadding: number]> {
  const res = await fetch(getBaseUrl() + '/VSP/V3/QueryCustomizeConfig', {
    method: 'POST',
    headers: { SessionTicket: getSessionTicket() },
    body: JSON.stringify({
      key: 'CatchupPostPadding,CatchupPrePadding',
      queryType: '2',
    }),
  });

  const data = await getDataFromResponse(res);
  const [prePadding, postPadding] = data.configurations[0].values;

  return [prePadding.values[0], postPadding.values[0]];
}
